import { subMonths, addMonths } from "date-fns"
import { getAvailableDatesForCalendar } from "@mallardbay/lib-shared-helpers"
import { useToast } from "@mallardbay/lib-react-components"

import { useAvailabilityQuery } from "~graphql/generated/graphql"
import { RESOURCE_TYPE } from "~config/constants"

const AVAILABILITY_PADDING_MONTHS = 2

export function useListingAvailability({
    listingId,
    referenceDate,
    numberOfGuests,
}: {
    listingId: string | null | undefined
    referenceDate: number
    numberOfGuests: number
}) {
    const startDate = subMonths(
        referenceDate,
        AVAILABILITY_PADDING_MONTHS
    ).getTime()

    const endDate = addMonths(
        referenceDate,
        AVAILABILITY_PADDING_MONTHS
    ).getTime()

    const { availability, isLoading, error, refetch } = useAvailability({
        resourceType: RESOURCE_TYPE.LISTING,
        resourceId: listingId,
        startDate: startDate,
        endDate,
    })
    const availableDates = getAvailableDatesForCalendar(
        availability,
        numberOfGuests
    )

    return { availability, availableDates, isLoading, error, refetch }
}

function useAvailability({
    resourceType,
    resourceId,
    startDate,
    endDate,
}: {
    resourceType: string | null | undefined
    resourceId: string | null | undefined
    startDate: number
    endDate: number
}) {
    const { showError } = useToast()

    const {
        data,
        loading: isLoading,
        error,
        refetch,
    } = useAvailabilityQuery({
        variables: {
            data: {
                resource_id: resourceId!,
                resource_type: resourceType!,
                start_date: startDate,
                end_date: endDate,
            },
        },
        skip: !resourceType || !resourceId,
        fetchPolicy: "no-cache",
        onError: showError,
    })
    const availability = data?.availability ?? []

    return { availability, isLoading, error, refetch }
}
